import { Initiative, PLOT_STATUS } from '@schema/initiative'
import type { LegalInfoFormValues } from '@app/pages/dashboard/initiative/shared/validation/initiativeValidation'

export const legalInfoDefaultValues = (
  initiative: Partial<Initiative>,
): LegalInfoFormValues => ({
  potentialPlotStatus: initiative.potentialPlotStatus ?? PLOT_STATUS.noPlot,
  potentialPlotAddress: initiative.potentialPlotAddress ?? '',
  permit: initiative.permit ?? false,
  financingRequirementsConstruction:
    initiative.financingRequirementsConstruction ?? false,
  financingRequirementsPlanning:
    initiative.financingRequirementsPlanning ?? false,
  kvkRegistration: initiative.kvkRegistration ?? false,
})

export type LegalInfoEditPayload = {
  potentialPlotStatus: LegalInfoFormValues['potentialPlotStatus']
  potentialPlotAddress: string
  permit: boolean
  financingRequirementsConstruction: boolean
  financingRequirementsPlanning: boolean
  kvkRegistration: boolean
}

export const legalInfoToEditPayload = (
  values: LegalInfoFormValues,
): LegalInfoEditPayload => ({
  potentialPlotStatus: values.potentialPlotStatus,
  potentialPlotAddress: values.potentialPlotAddress,
  permit: values.permit,
  financingRequirementsConstruction: values.financingRequirementsConstruction,
  financingRequirementsPlanning: values.financingRequirementsPlanning,
  kvkRegistration: values.kvkRegistration,
})
